/*
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-08-08 13:43:57
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/config/config.production.ts
 * @Description: 头部注释配置模板
 */
export default {
  API_URL: 'https://api.deyouhui.com.cn',
  CAR_URL: 'https://api.deyouhui.com.cn',
  BACKEND_URL: 'https://backend.deyouhui.com.cn',
};
